<ion-grid class="slider">
    <ion-row *ngIf="question.viewType === QuestionViewType.Top">
        <ion-col size="12">
            <p *ngIf="!hideQuestionTitle"
               [innerHtml]="getParsedDescription( getText(question.globalizationConfig, 'title') )  "
               [ngClass]="{ highlight:
                                    highlightSelfOrManagerEvalAnswer && question.type &&
                                    (question.type === QuestionConfigType.GoalsFinalGrade ||
                                      question.type === QuestionConfigType.FinalGrade ||
                                      question.type === QuestionConfigType.PrinciplesFinalGrade ||
                                      question.type === QuestionConfigType.LeadershipFinalGrade)
                                }">
            </p>
            <ng-container *ngIf="showRequiredBadge(formGroup, question.currentIndex)">
                <p class="required"> ({{ "generic.obligatoryField" | translate }}) </p>
            </ng-container>
        </ion-col>
    </ion-row>
    <ion-row>
        <ion-col size="2"></ion-col>
        <ion-col *ngFor="let opValue of question.typeConfig.possibleValues; let vIndex = index"
                 [style.color]="question.typeConfig.colors[vIndex]">
            <b class="description-modal">
                {{ getTextGlobalized(question.typeConfig.possibleValuesGlobalized, vIndex) }}
                <ion-icon
                        *ngIf="question.typeConfig.description && question.typeConfig.description[selectedLanguage][vIndex]"
                        class="bp-question-fill"
                        [matTooltip]="descriptionTooltip"
                        (mouseenter)="setTooltip(question, vIndex)"
                        (click)="openDescriptionConcept(question.typeConfig.possibleValuesGlobalized[selectedLanguage], question.typeConfig.description[selectedLanguage], vIndex)">
                </ion-icon>
            </b>
        </ion-col>
    </ion-row>
    <ion-row>
        <ion-col *ngIf="question.viewType === QuestionViewType.Left || question.viewType === null" size="2">
            <p *ngIf="!hideQuestionTitle"
               [innerHtml]="getParsedDescription( getText(question.globalizationConfig, 'title') )  "
               [ngClass]="{ highlight:
                                    highlightSelfOrManagerEvalAnswer && question.type &&
                                    (question.type === QuestionConfigType.GoalsFinalGrade ||
                                      question.type === QuestionConfigType.FinalGrade ||
                                      question.type === QuestionConfigType.PrinciplesFinalGrade ||
                                      question.type === QuestionConfigType.LeadershipFinalGrade)
                                }">
            </p>
            <ng-container *ngIf="showRequiredBadge(formGroup, question.currentIndex)">
                <p class="required"> ({{ "generic.obligatoryField" | translate }}) </p>
            </ng-container>
        </ion-col>
        <ion-col *ngIf="question.viewType !== QuestionViewType.Left && question.viewType !== null" size="2">
        </ion-col>

        <ion-col *ngFor=" let opValue of question.typeConfig.possibleValues; let vIndex = index"
                 [size]="10 / question.typeConfig.possibleValues.length">
            <div class="circle"
                 [ngClass]="
                                    {
                                        selected: formGroup.get('field' + question.currentIndex + (isManagerComment ? 'Comment' : ''))?.value === opValue
                                    }"
                 [style.borderColor]="question.typeConfig.colors[vIndex]"
                 [style.backgroundColor]="formGroup.get('field' + question.currentIndex + (isManagerComment ? 'Comment' : ''))?.value === opValue
                                                                    ? question.typeConfig.colors[vIndex]
                                                                    : 'transparent'
                                                                 "
                 (click)="setRangeValue('field' + question.currentIndex + (isManagerComment ? 'Comment' : ''), 
                                                 opValue, 
                                                 question.typeConfig, 
                                                 vIndex)"
            ></div>
        </ion-col>
    </ion-row>
    <ion-row *ngIf="evaluation && getQuestionAnswer(question, 0) && !hideSubordinateAnswer">
        <app-question-answer
                style="width: 100%"
                [question]="question"
                [evaluation]="evaluation"
                [groupIndex]="0"
                [managerAnswer]="managerAnswer"
                [answer]="getQuestionAnswer(question, 0)"
        ></app-question-answer>
    </ion-row>
</ion-grid>